import { render, staticRenderFns } from "./CustomerServiceFooter.vue?vue&type=template&id=489d9d38&scoped=true&"
import script from "./CustomerServiceFooter.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d9d38",
  null
  
)

export default component.exports